import React from 'react';
import './Bookcases.css';
import GalleryTemplate from "../gallery template/GalleryTemplate";

class Bookcases extends React.Component {

    componentDidMount() {
    }

    render() {
        return (
            <div className={'page'}>
                <div className={'bookcases'}>
                    <h1 className={'pageTitle'}>Bespoke Bookcases & Custom Shelving Solutions</h1>
                    <p className={'pageDescription'}>Discover the perfect home for your cherished collection with our custom-designed bookcases. From expansive floor-to-ceiling libraries to integrated shelving units and stylish display solutions, we craft bespoke joinery that brings both beauty and intelligent storage to any room. Maximize your space with shelving tailored precisely to your needs and aesthetic.</p>
                    <GalleryTemplate
                        title={'Traditional Cream Library Bookcases'}
                        description={'Classic and inviting, these bespoke cream library bookcases provide extensive shelving for a large collection and incorporate a convenient study or display area.'}
                        width={[2,2]}
                        height={[1,1]}
                        images={[
                            '/gallery/Bookcases/1/IMG-20200623-WA0001.jpg',
                            '/gallery/Bookcases/1/IMG-20200623-WA0000_1.jpg'
                        ]}/>
                    <GalleryTemplate
                        title={'Bespoke Grey Living Room Bookcase & Media Centre'}
                        description={'Our bespoke joinery creates elegant solutions like this expansive grey bookcase and media centre, offering extensive storage and display space for your living area.'}
                        width={[4]}
                        height={[3]}
                        images={[
                            '/gallery/Bookcases/2/IMG-20200623-WA0003.jpg'
                        ]}/>
                    <GalleryTemplate
                        title={'Bespoke White Integrated Bookcases'}
                        description={'These custom-fitted white bookcases offer extensive, versatile shelving for a vast collection of books, binders, and cherished decorative items, designed to maximise vertical storage.'}
                        width={[3]}
                        height={[4]}
                        images={[
                            '/gallery/Bookcases/3/IMG-20200625-WA0000_1.jpg'
                        ]}/>
                    <GalleryTemplate
                        title={'Floor-to-Ceiling White Bookcases'}
                        description={'Create an impressive home library with our custom floor-to-ceiling white bookcases, designed to beautifully display your entire book collection.'}
                        width={[4,3]}
                        height={[3,4]}
                        images={[
                            '/gallery/Bookcases/9/IMG-20210422-WA0002_1.jpg',
                            '/gallery/Bookcases/9/IMG-20210422-WA0004.jpg'
                        ]}/>
                    <GalleryTemplate
                        title={'Custom Alcove Bookcases and Media Unit'}
                        description={'Maximise your living room\'s potential with these elegant white custom-built alcove bookcases, providing ample storage and display space, beautifully framing a central fireplace and integrated TV unit.'}
                        width={[4]}
                        height={[3]}
                        images={[
                            '/gallery/Bookcases/11/IMG-20220121-WA0000.jpg',
                            '/gallery/Bookcases/11/IMG-20220121-WA0001.jpg',
                            '/gallery/Bookcases/11/IMG-20220119-WA0000.jpg',
                            '/gallery/Bookcases/11/IMG-20220119-WA0002_1.jpg'
                        ]}/>
                    <GalleryTemplate
                        title={'Bespoke Under-Stair Bookcase with Integrated Lighting'}
                        description={'Transform unused space with our custom-built under-stair bookcase, featuring illuminated shelves to beautifully showcase your books and decor, adding warmth and character to your hallway.'}
                        width={[4]}
                        height={[3]}
                        images={[
                            '/gallery/Bookcases/13/IMG-20240512-WA0013.jpg',
                            '/gallery/Bookcases/13/IMG-20240512-WA0014.jpg'
                        ]}/>
                    <GalleryTemplate
                        title={'False Chimney Breast with TV Insert'}
                        description={' A stylish and functional media unit custom-designed with a recessed television area, modern blue base cabinets, and warm wooden floating shelves for a complete living room solution.'}
                        width={[3]}
                        height={[4]}
                        images={[
                            '/gallery/Bookcases/5/IMG-20200918-WA0000.jpg'
                        ]}/>
                    <GalleryTemplate
                        title={'Custom Window Seat with Integrated Storage'}
                        description={'Maximise your space with a tailor-made window seat, featuring convenient open shelving underneath for books or decor, perfect for a cosy reading nook.'}
                        width={[3]}
                        height={[4]}
                        images={[
                            '/gallery/Bookcases/7/IMG-20210103-WA0004.JPG'
                        ]}/>
                    <GalleryTemplate
                        title={'Modern Hallway Storage Bench with Coat Hooks'}
                        description={'Organise your entryway with this sleek, custom-fitted hallway storage solution, featuring a long bench with cubby shelving and a series of stylish coat hooks.'}
                        width={[3]}
                        height={[4]}
                        images={[
                            '/gallery/Bookcases/8/IMG-20210103-WA0000.JPG',
                            '/gallery/Bookcases/8/IMG-20210103-WA0001.JPG'
                        ]}/>
                    <GalleryTemplate
                            title={'Elegant Boot Room & Utility Storage'}
                            description={'Transform your utility or boot room with custom joinery, providing a dedicated space for coats, shoes, and outdoor gear in a sophisticated dark green finish.'}
                            width={[3]}
                            height={[4]}
                            images={[
                            '/gallery/Bookcases/10/IMG-20210920-WA0000.jpg',
                            '/gallery/Bookcases/10/IMG-20220119-WA0001.jpg'
                        ]}/>
                    <GalleryTemplate
                        title={'Unique Playroom Storage & Play Units'}
                        description={'Ignite imagination with custom-designed play units for children\'s rooms, including house-shaped shelving and a detailed play kitchen area, crafted for both fun and organised storage.'}
                        width={[3]}
                        height={[4]}
                        images={[
                            '/gallery/Bookcases/12/IMG-20220121-WA0002.JPG',
                            '/gallery/Bookcases/12/IMG-20220121-WA0003.JPG'
                        ]}/>
                    <GalleryTemplate
                        title={'Custom Dark Blue Built-in Bookcase'}
                        description={'This striking bespoke bookcase, finished in a sophisticated dark blue, offers extensive open shelving for display and lower shaker-style cabinets for concealed storage, providing a highly functional and elegant solution for any living space.'}
                        width={[3]}
                        height={[4]}
                        images={[
                            '/gallery/Bookcases/14/IMG-20250725-WA0000.JPG'
                        ]}/>
                </div>
            </div>
        );
    }
}

export default Bookcases;
